import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "highlight_area",
  "use": "highlight_area-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"highlight_area\"><g clip-path=\"url(#highlight_area_clip0_3271_101161)\"><path d=\"M10 13h2v2h1v-2h2v-1h-2v-2h-1v2h-2v1zM6 13h2v-1H6v1zM4 13v-1H2v-2H1v2a1 1 0 001 1h2zM12 8h1V6h-1v2zM12 2v2h1V2a1 1 0 00-1-1h-2v1h2zM1 8h1V6H1v2zM6 2h2V1H6v1zM2 4V2h2V1H2a1 1 0 00-1 1v2h1z\" /></g><defs><clipPath id=\"highlight_area_clip0_3271_101161\"><path d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol